/* Maison Byōbu · 04/11/2026 (Marcel, avant la tranche 2 de la pub) : sur la fiche œuvre, juste après la phrase de
   l'œuvre, un vrai avis repris tel quel de la liste « Ils nous ont confié leurs murs » (celui sur la pose, sinon le
   premier) et les trois engagements déjà écrits dans le bandeau vert. Aucun texte nouveau, aucun prix. Rien ne
   s'affiche si la fiche n'a pas cette structure. Retour arrière : retirer la ligne de layout/theme.liquid. */
(() => {
  const comptoir = document.querySelector('section.comptoir');
  if (!comptoir || comptoir.querySelector('.mb-confiance')) return;
  const ancre = comptoir.querySelector('.mb-phrase') || comptoir.querySelector('h1');
  if (!ancre) return;
  const st = document.createElement('style');
  st.textContent = '.mb-confiance{margin:16px 0 4px;display:grid;gap:14px;max-width:34rem}'
    + '.mb-confiance__avis{margin:0;padding:12px 14px;border-left:3px solid #CCFF00;background:#F7F7F7}'
    + '.mb-confiance__etoiles{display:block;font-size:14px;letter-spacing:2px;color:#111;margin:0 0 4px}'
    + '.mb-confiance__avis blockquote{margin:0;font-size:15px;line-height:1.45;color:#111}'
    + '.mb-confiance__avis figcaption{margin:6px 0 0;font-size:13px;color:#6B665E}'
    + '.mb-confiance__engagements{list-style:none;margin:0;padding:0;display:grid;gap:6px;font-size:14px;line-height:1.35;color:#111}'
    + '.mb-confiance__engagements li{display:flex;gap:8px;align-items:baseline;margin:0}'
    + '.mb-confiance__engagements li::before{content:"✓";font-weight:700;color:#111}';
  document.head.appendChild(st);
  const bloc = document.createElement('div');
  bloc.className = 'mb-confiance';
  const avis = [...document.querySelectorAll('.ds-avis__complets > li')];
  const choisi = avis.find((li) => /La pose est beaucoup plus simple/.test(li.textContent)) || avis[0];
  if (choisi) {
    const texte = choisi.querySelector('p:not(.ds-avis__qui)');
    const qui = choisi.querySelector('.ds-avis__qui');
    const etoiles = choisi.querySelector('.ds-avis__etoiles');
    if (texte && qui) {
      const fig = document.createElement('figure');
      fig.className = 'mb-confiance__avis';
      const e = document.createElement('span');
      e.className = 'mb-confiance__etoiles';
      e.setAttribute('aria-hidden', 'true');
      e.textContent = etoiles ? etoiles.textContent.trim() : '★★★★★';
      const q = document.createElement('blockquote');
      q.textContent = texte.textContent.trim();
      const c = document.createElement('figcaption');
      c.textContent = [...qui.childNodes].filter((n) => n.nodeType === 3).map((n) => n.textContent).join('').trim();
      fig.append(e, q, c);
      bloc.append(fig);
    }
  }
  const ul = document.createElement('ul');
  ul.className = 'mb-confiance__engagements';
  ['Échantillon à 5 €, remboursé sur votre mur', 'Livraison offerte', 'Votre plan de pose sous 24 h'].forEach((t) => {
    const li = document.createElement('li');
    li.textContent = t;
    ul.append(li);
  });
  bloc.append(ul);
  ancre.after(bloc);
})();
